import React from "react";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const Breadcrumb = ({title,parent}) => {
	return (
    <Container fluid={true}>
      <div className='page-header'>
        <Row>
          <Col lg='6'>
            <ol className='breadcrumb pull-left'>
              <li className='breadcrumb-item'>
                <Link to='/dashboard'>
                  <Home />
                </Link>
              </li>
              <li className='breadcrumb-item'>{parent}</li>
              <li className='breadcrumb-item active'>{title}</li>
            </ol>
          </Col>
          <Col lg='6'>
            <div className='page-header-left pull-right'>
              <h3>
                {title}
                <small>Dashboard Eagle panel</small>
              </h3>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumb;
